import { t } from "i18next";
import type { ConnectionsTableColumnsKeys } from "./types";

export const connectionsTableColumnsKeys: Record<
  ConnectionsTableColumnsKeys,
  ConnectionsTableColumnsKeys
> = {
  activity: "activity",
  additionalInformation: "additionalInformation",
  birthday: "birthday",
  connectedAs: "connectedAs",
  industry: "industry",
  person: "person",
  role: "role",
  title: "title",
};

export const getConnectionsTableTitles = () => {
  return {
    [connectionsTableColumnsKeys.activity]: t("contactsPage.activities.activity"),
    [connectionsTableColumnsKeys.additionalInformation]: t("contactsPage.additionalInfo"),
    [connectionsTableColumnsKeys.birthday]: t("settingsPage.general.birthday"),
    [connectionsTableColumnsKeys.connectedAs]: t("contactsPage.connectedAs"),
    [connectionsTableColumnsKeys.industry]: t("contactsPage.activities.industry"),
    [connectionsTableColumnsKeys.person]: t("common.person"),
    [connectionsTableColumnsKeys.role]: t("contactsPage.activities.role"),
    [connectionsTableColumnsKeys.title]: t("common.title"),
  };
};
